<template>
    <div v-if="statistics">
                                
        <h4>own_record</h4>
        <table class="table" v-if="statistics.own_record">
            <tr>
                <td>total</td>
                <td>average</td>
            </tr>
            <tr>
                <td>
                    <div v-for="value, name in statistics.own_record.total">
                        {{ name }}: {{ value }}
                    </div>
                </td>
                <td>
                    <div v-for="value, name in statistics.own_record.average">
                        {{ name }}: {{ value }}
                    </div>
                </td>
            </tr>
        </table>

        <h4>opponents</h4>
        <table class="table" v-if="statistics.opponents">
            <tr>
                <td>total</td>
                <td>average</td>
            </tr>
            <tr>
                <td>
                    <div v-for="value, name in statistics.opponents.total">
                        {{ name }}: {{ value }}
                    </div>
                </td>
                <td>
                    <div v-for="value, name in statistics.opponents.average">
                        {{ name }}: {{ value }}
                    </div>
                </td>
            </tr>
        </table>

        <div v-if="statistics.players">
            <h4>players</h4>

            <table class="table">
                <tr>
                    <th>full_name</th>
                    <th>position</th>
                    <td>total</td>
                    <td>average</td>
                </tr>
                <tr v-for="player in statistics.players">
                    <td>{{ player.full_name }}</td>
                    <td>{{ player.position }}</td>
                    <td>
                        <div v-for="value, name in player.total">
                            {{ name }}: {{ value }}
                        </div>
                    </td>
                    <td>
                        <div v-for="value, name in player.average">
                            {{ name }}: {{ value }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'NBASeasonalStatistics',
    props: {
        statistics: '',
    },
    data: function() {
        return {            
            
        }
    }, 
}
</script>

